function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import { stateGo } from 'redux-ui-router';
import { RouteParams, RouteCurrentStateSelector } from 'invision-core/src/components/router/router.selectors';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import CustomerLocaleKeys from '../../../../locales/keys';
import { ServicesAndUsagesTabsSelector } from '../../../../reducers/selectors/customer.services.and.usage.selectors';
import { ActiveServicesSelector, BulkServicesPageSizeSelector, BulkServicesSearchStringSelector, HasOffCycleChargesSelector, IncludeStatusFilterSelector, IncludeTypeOfServiceFilterSelector, ResumeServiceReasonCodesSelector, SERVICE_ACTION_OPTIONS, ServicesSuspendResumeMenuOptionsSelector, SuspendServiceReasonCodesSelector } from '../../../../reducers/selectors/services.selectors';
import { USAGE_CAPS_URL } from '../../servicesAndUsage/usageCaps/usage.caps.constants';
import { NON_BULK_SERVICE_CATEGORIZATION } from './services/services.list.constants';
import { SERVICES_AND_SHARED_ENTITLEMENTS_TAB } from '../services.and.usage.config';
import { ORDER_HISTORY_DETAILS_STATE_NAME } from '../../orderHistory/order.history.config';
import { removeBulkServicesStatusFilter, searchServices, setSelectAccountLevel, suspendOrResumeServices } from '../../../../reducers/actions/services.actions';
import { resetSharedEntitlementTabData } from '../../../../reducers/actions/shared.entitlements.actions';
import { CurrentCustomerIdSelector, SelectedCustomerActiveProductsSelector } from '../../../../reducers/selectors/customer.selectors';
import { retrieveConvergentBillerAccountDetails, retrieveConvergentBillerSubscriberSummary } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { CurrentAccountServicesSelector, CombinedEntitlementTypesSelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { TRANSFER_STATE_NAME } from '../../orders/transfer/transfer.wizard.config';
import { retrieveSubscriberFinanceDetails } from '../../../../reducers/actions/customer.devices.actions';
import { FeatureToggleConstants } from 'invision-core';
import { FeatureTogglesSelector } from 'invision-core/src/components/featureToggle/featureToggle.selectors';
import { clearSearchEntitlementFiltersRecoverableUIState } from '../../../../reducers/actions/usage.details.actions';
import { RESUME_SERVICES_REDIRECT, SUSPEND_SERVICES_REDIRECT } from '../../../../reactRoutes';
var ServicesAndUsageController = /*#__PURE__*/function () {
  function ServicesAndUsageController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ServicesAndUsageController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      handleServiceMenuOptions: this.handleServiceMenuOptions.bind(this),
      onTabSelected: this.onTabSelected.bind(this),
      openSuspendOrResumeServiceModal: this.openSuspendOrResumeServiceModal.bind(this),
      SERVICES_AND_SHARED_ENTITLEMENTS_TAB: SERVICES_AND_SHARED_ENTITLEMENTS_TAB,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServicesAndUsageController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.FeatureToggleConfig, CODES.ReasonCodes, CODES.ServiceAttribute, CODES.UsageCapMenuTitle];
      var controllerActions = {
        clearSearchEntitlementFiltersRecoverableUIState: clearSearchEntitlementFiltersRecoverableUIState,
        fetchCodeTypes: fetchCodeTypes,
        removeBulkServicesStatusFilter: removeBulkServicesStatusFilter,
        resetSharedEntitlementTabData: resetSharedEntitlementTabData,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveSubscriberFinanceDetails: retrieveSubscriberFinanceDetails,
        searchServices: searchServices,
        setSelectAccountLevel: setSelectAccountLevel,
        stateGo: stateGo,
        suspendOrResumeServices: suspendOrResumeServices
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          activeServices: ActiveServicesSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          combinedEntitlementTypes: CombinedEntitlementTypesSelector(store),
          currentAccountServices: CurrentAccountServicesSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          customerActiveProducts: SelectedCustomerActiveProductsSelector(store),
          features: FeatureTogglesSelector(store),
          hasOffCycleCharges: HasOffCycleChargesSelector(store),
          pageSize: BulkServicesPageSizeSelector(store),
          resumeServiceReasonCodes: ResumeServiceReasonCodesSelector(store),
          routeParams: RouteParams(store),
          routeState: RouteCurrentStateSelector(store),
          searchString: BulkServicesSearchStringSelector(store),
          selectedStatusFilter: IncludeStatusFilterSelector(store),
          selectedTypeOfServiceFilter: IncludeTypeOfServiceFilterSelector(store),
          servicesSuspendResumeMenuOptions: ServicesSuspendResumeMenuOptionsSelector(store),
          suspendServiceReasonCodes: SuspendServiceReasonCodesSelector(store),
          tabs: ServicesAndUsagesTabsSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.optionalParams = {
        customerId: this.state.currentCustomerId,
        orderId: this.state.routeParams.orderId
      };
      if (this.state.routeParams.orderId) {
        this.orderHistoryState = {
          name: ORDER_HISTORY_DETAILS_STATE_NAME,
          params: {
            orderId: this.state.routeParams.orderId
          }
        };
      }

      //When we navigate from a React page, make sure that FeatureToggleConfig code table is loaded before making RetrieveSubscriberFinanceDetails call.
      Promise.resolve(this.actions.fetchCodeTypes(CODES.FeatureToggleConfig)).then(function () {
        if (!_this.state.features[FeatureToggleConstants.OFFCYCLE_BYPASS_ARM]) {
          _this.actions.retrieveSubscriberFinanceDetails(_this.state.currentCustomerId).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onTabSelected",
    value: function onTabSelected(selected) {
      this.actions.stateGo(selected.state, selected.params);
    }
  }, {
    key: "handleServiceMenuOptions",
    value: function handleServiceMenuOptions(option) {
      if (SERVICE_ACTION_OPTIONS.TRANSFER === option.item.id) {
        this.actions.stateGo(TRANSFER_STATE_NAME);
      } else if (SERVICE_ACTION_OPTIONS.USAGE_CAPS === option.item.id) {
        this.navigateToUsageCapsPage();
      } else {
        this.openSuspendOrResumeServiceModal(option);
      }
    }
  }, {
    key: "openSuspendOrResumeServiceModal",
    value: function openSuspendOrResumeServiceModal(options) {
      if (options.EllipsisMenuOption === NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK || options.EllipsisMenuOption === NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK_WITH_MANAGED_FEATURES) {
        var _options$ServiceIdent, _options$ServiceIdent2;
        this.actions.stateGo(SUSPEND_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: (_options$ServiceIdent = options === null || options === void 0 ? void 0 : (_options$ServiceIdent2 = options.ServiceIdentifier) === null || _options$ServiceIdent2 === void 0 ? void 0 : _options$ServiceIdent2.Value) !== null && _options$ServiceIdent !== void 0 ? _options$ServiceIdent : null
        });
      } else if (options.EllipsisMenuOption === NON_BULK_SERVICE_CATEGORIZATION.SUSPENDED_NON_BULK || options.EllipsisMenuOption === NON_BULK_SERVICE_CATEGORIZATION.SUSPENDED_NON_BULK_WITH_MANAGED_FEATURES) {
        var _options$ServiceIdent3, _options$ServiceIdent4;
        this.actions.stateGo(RESUME_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: (_options$ServiceIdent3 = options === null || options === void 0 ? void 0 : (_options$ServiceIdent4 = options.ServiceIdentifier) === null || _options$ServiceIdent4 === void 0 ? void 0 : _options$ServiceIdent4.Value) !== null && _options$ServiceIdent3 !== void 0 ? _options$ServiceIdent3 : null
        });
      } else if (options.item) {
        if (options.item.id === SERVICE_ACTION_OPTIONS.SUSPEND) {
          this.actions.stateGo(SUSPEND_SERVICES_REDIRECT, {
            customerId: this.state.currentCustomerId
          });
        } else if (options.item.id === SERVICE_ACTION_OPTIONS.RESUME) {
          this.actions.stateGo(RESUME_SERVICES_REDIRECT, {
            customerId: this.state.currentCustomerId
          });
        }
      }
    }
  }, {
    key: "navigateToUsageCapsPage",
    value: function navigateToUsageCapsPage() {
      this.actions.setSelectAccountLevel(true);
      this.actions.stateGo(USAGE_CAPS_URL);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.resetSharedEntitlementTabData();
      this.actions.removeBulkServicesStatusFilter();
      this.actions.clearSearchEntitlementFiltersRecoverableUIState();
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: ServicesAndUsageController,
  template: require('./services.and.shared.entitlements.template.html')
};